import { SVGProps } from "react";

export const SidebarArrowIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 15.9999C9.49924 15.8683 9.52446 15.7379 9.57423 15.616C9.62399 15.4942 9.69732 15.3834 9.79 15.2899L13.1 11.9999L9.92 8.69994C9.73375 8.51258 9.62921 8.25912 9.62921 7.99494C9.62921 7.73075 9.73375 7.4773 9.92 7.28994C10.013 7.19621 10.1236 7.12182 10.2454 7.07105C10.3673 7.02028 10.498 6.99414 10.63 6.99414C10.762 6.99414 10.8927 7.02028 11.0146 7.07105C11.1364 7.12182 11.247 7.19621 11.34 7.28994L15.2 11.2899C15.3832 11.4769 15.4859 11.7282 15.4859 11.9899C15.4859 12.2517 15.3832 12.503 15.2 12.6899L11.2 16.6899C11.107 16.7837 10.9964 16.8581 10.8746 16.9088C10.7527 16.9596 10.622 16.9857 10.49 16.9857C10.358 16.9857 10.2273 16.9596 10.1054 16.9088C9.98356 16.8581 9.87296 16.7837 9.78 16.6899C9.60132 16.5046 9.50102 16.2574 9.5 15.9999Z"
      fill="white"
    />
  </svg>
);
export const DefaultImage = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4625 11.6214C11.4625 13.4623 10.0299 14.9546 8.26265 14.9546C6.49541 14.9546 5.06278 13.4623 5.06278 11.6214C5.06278 9.78057 6.49541 8.28825 8.26265 8.28825C10.0299 8.28825 11.4625 9.78057 11.4625 11.6214Z"
      fill="#C2CBD9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.000732422 6.00019C0.000732422 4.15932 1.43337 2.66699 3.20061 2.66699H28.7996C30.5668 2.66699 31.9995 4.15932 31.9995 6.00019V25.9994C31.9995 27.8403 30.5669 29.3326 28.7996 29.3326H26.6874C26.6804 29.3326 26.6734 29.3326 26.6664 29.3326H3.92988C3.92386 29.3326 3.91783 29.3326 3.91181 29.3326H3.20061C1.43337 29.3326 0.000732422 27.8403 0.000732422 25.9994V6.00019ZM3.20061 5.16689H28.7996C29.2414 5.16689 29.5996 5.53997 29.5996 6.00019V16.3866L22.6474 9.33343L10.8198 21.3329L7.33568 17.7982L2.40064 22.805V6.00019C2.40064 5.53997 2.7588 5.16689 3.20061 5.16689Z"
      fill="#C2CBD9"
    />
  </svg>
);
export const DeleteIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.187 8H17.812L17.117 19.125C17.0852 19.6328 16.8611 20.1094 16.4902 20.4577C16.1194 20.8061 15.6298 21 15.121 21H8.879C8.37022 21 7.88058 20.8061 7.50975 20.4577C7.13893 20.1094 6.9148 19.6328 6.883 19.125L6.187 8ZM19 5V7H5V5H8V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V5H19ZM10 5H14V4H10V5Z"
      fill="#EB5757"
    />
  </svg>
);
export const HorizontalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={24} height={24} rx={12} fill="#fff" />
    <path
      d="M17.6 16.2H6.4M17.6 12H6.4m11.2-4.2H6.4"
      stroke="#0F6FDF"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export const VerticalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={24}
      width={24}
      height={24}
      rx={12}
      transform="rotate(90 24 0)"
      fill="#F5F5F5"
    />
    <path
      d="M7.8 17.6V6.4M12 17.6V6.4m4.2 11.2V6.4"
      stroke="#999"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export const MinusIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_829_20251)">
      <path
        d="M4.16699 9.99988H15.8337"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_829_20251">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const PlusIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_829_20245)">
      <path
        d="M10 4.16655V15.8332"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.16699 9.99988H15.8337"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_829_20245">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const LeftArrowIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33301 5L3.33301 10L8.33301 15"
      stroke="black"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.667 10H3.33366"
      stroke="black"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.8651 12.7436C14.8545 11.4675 15.3208 9.8622 15.1691 8.25433C15.0175 6.64647 14.2592 5.1568 13.0486 4.08839C11.8379 3.01998 10.2659 2.45309 8.65235 2.50304C7.03875 2.55299 5.50478 3.21604 4.36252 4.35728C3.21925 5.49932 2.55431 7.03449 2.50318 8.64995C2.45206 10.2654 3.0186 11.8396 4.08736 13.0517C5.15613 14.2638 6.64667 15.0226 8.25525 15.1734C9.86382 15.3243 11.4694 14.8559 12.7447 13.8636L12.7788 13.8994L16.1447 17.2674C16.2184 17.3411 16.306 17.3996 16.4023 17.4395C16.4986 17.4795 16.6018 17.5 16.7061 17.5C16.8103 17.5 16.9136 17.4795 17.0099 17.4395C17.1062 17.3996 17.1937 17.3411 17.2675 17.2674C17.3412 17.1936 17.3997 17.1061 17.4396 17.0097C17.4795 16.9134 17.5 16.8101 17.5 16.7058C17.5 16.6015 17.4795 16.4982 17.4396 16.4018C17.3997 16.3055 17.3412 16.2179 17.2675 16.1442L13.9008 12.7769C13.8892 12.7655 13.8773 12.7544 13.8651 12.7436ZM12.2178 5.48049C12.6658 5.92142 13.0221 6.44672 13.2662 7.02609C13.5102 7.60546 13.6372 8.22744 13.6397 8.85615C13.6423 9.48485 13.5204 10.1078 13.2811 10.6892C13.0418 11.2705 12.6898 11.7987 12.2454 12.2433C11.801 12.6878 11.273 13.04 10.6919 13.2794C10.1108 13.5188 9.48804 13.6408 8.85959 13.6382C8.23113 13.6356 7.6094 13.5086 7.03026 13.2645C6.45112 13.0203 5.92603 12.6639 5.48527 12.2157C4.60446 11.3201 4.11309 10.1126 4.11821 8.85615C4.12332 7.59973 4.6245 6.39623 5.51258 5.5078C6.40065 4.61937 7.60367 4.11799 8.85959 4.11288C10.1155 4.10776 11.3226 4.59932 12.2178 5.48049Z"
      fill="#999999"
    />
  </svg>
);
export const TickIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6113 23.7975C11.0023 23.7975 10.4255 23.5133 10.0559 23.0233L5.0537 16.4139C4.89905 16.2098 4.78614 15.9772 4.72144 15.7294C4.65673 15.4816 4.6415 15.2235 4.6766 14.9698C4.71171 14.7162 4.79646 14.4719 4.92603 14.251C5.0556 14.0301 5.22743 13.8369 5.4317 13.6825C5.6359 13.5274 5.86871 13.4141 6.11676 13.3492C6.36482 13.2842 6.62325 13.2689 6.87726 13.304C7.13126 13.3391 7.37584 13.424 7.59697 13.5538C7.8181 13.6836 8.01144 13.8558 8.1659 14.0605L11.4573 18.4061L19.7327 5.11728C20.0072 4.67852 20.4444 4.36653 20.9486 4.24973C21.4528 4.13294 21.9827 4.22089 22.4221 4.49428C23.3363 5.06268 23.6177 6.26668 23.0465 7.18228L13.2689 22.8763C13.102 23.1454 12.8719 23.3697 12.5987 23.5297C12.3254 23.6898 12.0173 23.7807 11.7009 23.7947C11.6701 23.7975 11.6421 23.7975 11.6113 23.7975Z"
      fill="#999999"
    />
  </svg>
);
export const ClockIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.8337 13.9998C26.8337 21.0874 21.0879 26.8331 14.0003 26.8331C6.91267 26.8331 1.16699 21.0874 1.16699 13.9998C1.16699 6.91214 6.91267 1.16646 14.0003 1.16646C21.0879 1.16646 26.8337 6.91214 26.8337 13.9998ZM3.50829 13.9998C3.50829 19.7944 8.20574 24.4919 14.0003 24.4919C19.7949 24.4919 24.4924 19.7944 24.4924 13.9998C24.4924 8.2052 19.7949 3.50776 14.0003 3.50776C8.20574 3.50776 3.50829 8.2052 3.50829 13.9998Z"
      fill="#999999"
    />
    <path
      d="M13.9997 5.83354C13.3553 5.83354 12.833 6.35587 12.833 7.00021V14.5447C12.833 14.5447 12.833 14.8488 12.9808 15.0776C13.0798 15.2716 13.234 15.4402 13.4366 15.5572L18.8264 18.6691C19.3844 18.9912 20.098 18.8 20.4201 18.242C20.7422 17.684 20.5511 16.9704 19.9931 16.6483L15.1663 13.8616V7.00021C15.1663 6.35588 14.644 5.83354 13.9997 5.83354Z"
      fill="#999999"
    />
  </svg>
);
export const TruckIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4031 5.41406V19.5563H10.1172H9.76719C9.66875 19.5563 9.58125 19.4906 9.55937 19.3922C9.275 17.7734 7.875 16.5594 6.17969 16.5594C4.48438 16.5594 3.09531 17.7734 2.81094 19.3813C2.78906 19.4797 2.7125 19.5453 2.60312 19.5453H0.896875C0.39375 19.5453 0 19.1406 0 18.6484V5.41406H12.4031ZM25.6812 20.0047C25.6812 21.4266 24.5328 22.575 23.1109 22.575C21.6891 22.575 20.5406 21.4266 20.5406 20.0047C20.5406 18.5828 21.6891 17.4344 23.1109 17.4344C24.5328 17.4344 25.6812 18.5828 25.6812 20.0047ZM24.0953 20.0047C24.0953 19.4688 23.6469 19.0203 23.1109 19.0203C22.575 19.0203 22.1266 19.4688 22.1266 20.0047C22.1266 20.5406 22.575 20.9891 23.1109 20.9891C23.6578 20.9891 24.0953 20.5406 24.0953 20.0047ZM8.75 20.0047C8.75 21.4266 7.60156 22.575 6.17969 22.575C4.75781 22.575 3.60938 21.4266 3.60938 20.0047C3.60938 18.5828 4.75781 17.4344 6.17969 17.4344C7.60156 17.4344 8.75 18.5828 8.75 20.0047ZM7.16406 20.0047C7.16406 19.4688 6.71562 19.0203 6.17969 19.0203C5.64375 19.0203 5.19531 19.4688 5.19531 20.0047C5.19531 20.5406 5.64375 20.9891 6.17969 20.9891C6.71562 20.9891 7.16406 20.5406 7.16406 20.0047ZM28 17.9047V18.5938C28 19.1188 27.5844 19.5453 27.0484 19.5453H26.6875C26.5891 19.5453 26.5016 19.4797 26.4797 19.3813C26.1953 17.7734 24.7953 16.5484 23.1109 16.5484C21.4266 16.5484 20.0156 17.7734 19.7422 19.3813C19.7203 19.4797 19.6438 19.5453 19.5344 19.5453H13.2016V8.75H17.0844C17.3578 8.76094 17.6203 8.87031 17.8062 9.05625L21.9625 13.5406C21.9953 13.5734 22.0609 13.6063 22.1156 13.6063H25.7578C26.5891 13.6063 27.2563 14.2734 27.2563 15.0938V17.7188H27.8031C27.9016 17.7078 28 17.8063 28 17.9047ZM20.125 13.2453L17.1172 9.93125C17.0734 9.89844 17.0187 9.86563 16.9531 9.86563H14.5578C14.4484 9.86563 14.35 9.96406 14.35 10.0734V13.3984C14.35 13.5078 14.4484 13.6063 14.5578 13.6063H19.9609C20.1469 13.6063 20.2344 13.3875 20.125 13.2453Z"
      fill="#999999"
    />
  </svg>
);
export const FlagIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.1875 4.2C22.925 4.025 22.575 4.025 22.3125 4.2C19.25 6.125 16.975 4.9 14.4375 3.5C11.8125 2.1 8.75 0.525001 4.8125 2.8875C4.55 3.15 4.375 3.4125 4.375 3.7625V15.75V16.0125V25.375C4.375 25.9 4.725 26.25 5.25 26.25C5.775 26.25 6.125 25.9 6.125 25.375V16.5375C9.0125 14.9625 11.1125 16.1 13.5625 17.4125C15.225 18.2875 17.0625 19.25 19.1625 19.25C20.3875 19.25 21.7875 18.9 23.1875 18.025C23.45 17.85 23.625 17.5875 23.625 17.2375V4.9875C23.625 4.6375 23.45 4.375 23.1875 4.2Z"
      fill="#999999"
    />
  </svg>
);
export const ProfileIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_73_12511)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0001 12.4963C9.49214 12.4963 7.72346 10.6903 7.45931 7.95567L7.08483 5.00119C6.85271 2.0985 9.22135 0 12.0001 0C14.7788 0 17.1475 2.0985 16.9152 5.00119L16.5408 7.95567C16.2765 10.6902 14.508 12.4963 12.0001 12.4963ZM21.5339 18.6666L21.7131 19.808C21.777 20.2154 21.6928 20.8134 21.3277 21.1123C21.2809 21.1506 21.2219 21.2081 21.1475 21.2808C20.4457 21.9659 18.3622 24.0001 12.0001 24.0001C5.63793 24.0001 3.55431 21.9659 2.85252 21.2808C2.77806 21.2081 2.71916 21.1506 2.67235 21.1123C2.30738 20.8134 2.22306 20.2154 2.28695 19.808L2.46629 18.6666C2.61643 17.7095 3.21784 16.8834 4.08231 16.4465L7.85443 14.539C7.97251 14.4793 8.06865 14.3893 8.14923 14.2888C9.24123 15.4434 10.5681 16.1226 12.0001 16.1226C13.4321 16.1226 14.7588 15.4434 15.8509 14.2888C15.9315 14.3893 16.0276 14.4793 16.1457 14.539L19.9179 16.4465C20.7822 16.8834 21.3837 17.7095 21.5339 18.6666Z"
        fill="#3E5189"
      />
    </g>
    <defs>
      <clipPath id="clip0_73_12511">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const RightArrowIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.49998 15.9999C9.49922 15.8683 9.52445 15.7379 9.57421 15.616C9.62398 15.4942 9.6973 15.3834 9.78998 15.2899L13.1 11.9999L9.91998 8.69994C9.73373 8.51258 9.62919 8.25912 9.62919 7.99494C9.62919 7.73075 9.73373 7.4773 9.91998 7.28994C10.0129 7.19621 10.1235 7.12182 10.2454 7.07105C10.3673 7.02028 10.498 6.99414 10.63 6.99414C10.762 6.99414 10.8927 7.02028 11.0146 7.07105C11.1364 7.12182 11.247 7.19621 11.34 7.28994L15.2 11.2899C15.3832 11.4769 15.4858 11.7282 15.4858 11.9899C15.4858 12.2517 15.3832 12.503 15.2 12.6899L11.2 16.6899C11.107 16.7837 10.9964 16.8581 10.8746 16.9088C10.7527 16.9596 10.622 16.9857 10.49 16.9857C10.358 16.9857 10.2273 16.9596 10.1054 16.9088C9.98355 16.8581 9.87295 16.7837 9.77998 16.6899C9.6013 16.5046 9.50101 16.2574 9.49998 15.9999Z"
      fill="black"
    />
  </svg>
);
export const MinimumDollarIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 14H10C9.71667 14 9.47917 14.0958 9.2875 14.2875C9.09583 14.4792 9 14.7167 9 15C9 15.2833 9.09583 15.5208 9.2875 15.7125C9.47917 15.9042 9.71667 16 10 16H11C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17C12.2667 17 12.4542 16.8792 12.5625 16.6375C12.6708 16.3958 12.8167 16.1833 13 16H14C14.2833 16 14.5208 15.9042 14.7125 15.7125C14.9042 15.5208 15 15.2833 15 15V12C15 11.7167 14.9042 11.4792 14.7125 11.2875C14.5208 11.0958 14.2833 11 14 11H11V10H14C14.2833 10 14.5208 9.90417 14.7125 9.7125C14.9042 9.52083 15 9.28333 15 9C15 8.71667 14.9042 8.47917 14.7125 8.2875C14.5208 8.09583 14.2833 8 14 8H13C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7333 7 11.5458 7.12083 11.4375 7.3625C11.3292 7.60417 11.1833 7.81667 11 8H10C9.71667 8 9.47917 8.09583 9.2875 8.2875C9.09583 8.47917 9 8.71667 9 9V12C9 12.2833 9.09583 12.5208 9.2875 12.7125C9.47917 12.9042 9.71667 13 10 13H13V14ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z"
      fill="#00C537"
    />
  </svg>
);
export const WarningIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.725 21C2.54167 21 2.375 20.9542 2.225 20.8625C2.075 20.7708 1.95834 20.65 1.875 20.5C1.79167 20.35 1.74584 20.1875 1.7375 20.0125C1.72917 19.8375 1.775 19.6667 1.875 19.5L11.125 3.5C11.225 3.33333 11.3542 3.20833 11.5125 3.125C11.6708 3.04167 11.8333 3 12 3C12.1667 3 12.3292 3.04167 12.4875 3.125C12.6458 3.20833 12.775 3.33333 12.875 3.5L22.125 19.5C22.225 19.6667 22.2708 19.8375 22.2625 20.0125C22.2542 20.1875 22.2083 20.35 22.125 20.5C22.0417 20.65 21.925 20.7708 21.775 20.8625C21.625 20.9542 21.4583 21 21.275 21H2.725ZM12 18C12.2833 18 12.5208 17.9042 12.7125 17.7125C12.9042 17.5208 13 17.2833 13 17C13 16.7167 12.9042 16.4792 12.7125 16.2875C12.5208 16.0958 12.2833 16 12 16C11.7167 16 11.4792 16.0958 11.2875 16.2875C11.0958 16.4792 11 16.7167 11 17C11 17.2833 11.0958 17.5208 11.2875 17.7125C11.4792 17.9042 11.7167 18 12 18ZM12 15C12.2833 15 12.5208 14.9042 12.7125 14.7125C12.9042 14.5208 13 14.2833 13 14V11C13 10.7167 12.9042 10.4792 12.7125 10.2875C12.5208 10.0958 12.2833 10 12 10C11.7167 10 11.4792 10.0958 11.2875 10.2875C11.0958 10.4792 11 10.7167 11 11V14C11 14.2833 11.0958 14.5208 11.2875 14.7125C11.4792 14.9042 11.7167 15 12 15Z"
      fill="#FFB345"
    />
  </svg>
);
export const SelectBtnIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.75 5H17.75M13.75 3V7M13.75 5H2.75M6.75 12H2.75M10.75 10V14M21.75 12H10.75M20.75 19H17.75M13.75 17V21M13.75 19H2.75"
      stroke="#0F6FDF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const TopToBottomIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 17C11.8326 17 11.6702 16.9656 11.5128 16.8969C11.3555 16.8282 11.2249 16.7366 11.1211 16.6221L5.34529 10.3015C5.1151 10.0496 5 9.729 5 9.33969C5 8.95038 5.1151 8.62977 5.34529 8.37786C5.57549 8.12595 5.86846 8 6.22422 8C6.57997 8 6.87294 8.12595 7.10314 8.37786L12 13.7366L16.8969 8.37786C17.1271 8.12596 17.42 8 17.7758 8C18.1315 8 18.4245 8.12596 18.6547 8.37786C18.8849 8.62977 19 8.95038 19 9.33969C19 9.729 18.8849 10.0496 18.6547 10.3015L12.8789 16.6221C12.7534 16.7595 12.6173 16.8571 12.4708 16.9148C12.3244 16.9725 12.1674 17.0009 12 17Z"
      fill="#999999"
    />
  </svg>
);
export const CarIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8486 3.1948C9.05334 3.15376 5.17037 3.21376 4.37093 5.36128L2.40677 9.97024C2.31966 9.87058 2.20541 9.79844 2.07797 9.76264L1.28717 9.54016C1.20022 9.5155 1.10925 9.50826 1.01949 9.51885C0.929727 9.52945 0.842941 9.55766 0.764113 9.60188C0.685285 9.6461 0.615966 9.70545 0.560135 9.77653C0.504305 9.84761 0.463062 9.92902 0.438775 10.0161L0.0262147 11.481C0.00159452 11.568 -0.0056175 11.6589 0.00499238 11.7487C0.0156023 11.8384 0.0438253 11.9251 0.0880422 12.0039C0.132259 12.0827 0.1916 12.152 0.26266 12.2079C0.33372 12.2637 0.415101 12.3049 0.502135 12.3292L1.29317 12.5519C1.31957 12.5591 1.34597 12.5615 1.37237 12.5658C1.22117 12.9426 1.12709 13.3569 1.12709 13.6034V18.9602C1.12709 19.2347 1.24229 19.3619 1.42517 19.4214V20.8485C1.42489 20.9752 1.44963 21.1007 1.49798 21.2178C1.54633 21.3348 1.61733 21.4412 1.70691 21.5308C1.79649 21.6204 1.90288 21.6914 2.01998 21.7398C2.13708 21.7881 2.26257 21.8128 2.38925 21.8126H4.97573C5.10242 21.8128 5.22791 21.7881 5.34501 21.7398C5.4621 21.6914 5.5685 21.6204 5.65808 21.5308C5.74766 21.4412 5.81866 21.3348 5.86701 21.2178C5.91536 21.1007 5.9401 20.9752 5.93982 20.8485V19.4738H18.0605V20.8485C18.0603 20.9752 18.0851 21.1006 18.1335 21.2177C18.1819 21.3348 18.2529 21.4412 18.3425 21.5308C18.4321 21.6203 18.5385 21.6913 18.6556 21.7397C18.7727 21.788 18.8982 21.8128 19.0249 21.8126H21.6109C21.7376 21.8128 21.8631 21.7881 21.9802 21.7398C22.0973 21.6914 22.2038 21.6204 22.2934 21.5308C22.383 21.4413 22.454 21.3349 22.5024 21.2178C22.5508 21.1007 22.5756 20.9752 22.5754 20.8485V19.4217C22.7585 19.3622 22.873 19.235 22.873 18.9604V13.6036C22.873 13.3571 22.7787 12.9429 22.6277 12.5661C22.6541 12.562 22.6805 12.5596 22.7069 12.5522L23.4982 12.3294C23.5852 12.3051 23.6666 12.2639 23.7376 12.208C23.8087 12.1522 23.868 12.0829 23.9122 12.0041C23.9564 11.9253 23.9846 11.8386 23.9951 11.7489C24.0057 11.6591 23.9985 11.5682 23.9739 11.4813L23.5618 10.0163C23.5375 9.92925 23.4962 9.84784 23.4404 9.77676C23.3845 9.70567 23.3152 9.64632 23.2363 9.6021C23.1575 9.55789 23.0707 9.52967 22.9809 9.51908C22.8911 9.50849 22.8001 9.51574 22.7132 9.5404L21.9224 9.76288C21.7949 9.79883 21.6807 9.87094 21.5933 9.97048L19.6292 5.36152C18.7724 3.18136 14.6437 3.23608 11.8484 3.19504L11.8486 3.1948ZM19.8543 10.2614C19.9009 10.3996 19.7617 10.4918 19.616 10.5002C19.616 10.5002 19.1398 10.5405 18.4832 10.5935C17.9835 9.42616 16.8224 8.60344 15.4772 8.60344C14.0009 8.60344 12.7477 9.59464 12.3457 10.9444C12.2343 10.9458 12.1049 10.9506 12.0015 10.9506C9.45821 10.9506 4.38413 10.5002 4.38413 10.5002C4.23869 10.4915 4.09925 10.3994 4.14581 10.2614C6.0999 4.30432 6.15821 4.75216 11.8921 4.8148C17.6257 4.8772 17.659 4.45168 19.8543 10.2614ZM15.4772 9.72928C15.8312 9.72805 16.1799 9.81497 16.4919 9.98219C16.804 10.1494 17.0694 10.3917 17.2645 10.6871C16.1161 10.7723 14.7944 10.8594 13.5627 10.9101C13.7399 10.5543 14.0131 10.2552 14.3514 10.0465C14.6898 9.83784 15.0797 9.72796 15.4772 9.72928ZM2.25773 11.6625C2.27501 11.6882 2.29181 11.7138 2.31101 11.7386H2.23661L2.25773 11.6625ZM3.52829 13.1586C4.03133 13.1505 6.73181 14.0594 6.73181 14.0594C7.06902 14.1544 7.36589 14.7918 7.36421 15.1422C7.35917 16.3223 4.31405 15.9126 3.07781 15.9174C2.99474 15.9176 2.91246 15.9014 2.83567 15.8696C2.75889 15.8379 2.68912 15.7914 2.63037 15.7326C2.57162 15.6739 2.52504 15.6042 2.4933 15.5274C2.46156 15.4506 2.44529 15.3683 2.44541 15.2853V13.7913C2.44541 13.4409 3.02525 13.1673 3.52829 13.1586ZM20.4718 13.1586C20.9749 13.167 21.5547 13.4409 21.5547 13.7913V15.2853C21.5549 15.3684 21.5386 15.4507 21.5069 15.5275C21.4752 15.6043 21.4286 15.674 21.3698 15.7328C21.3111 15.7916 21.2413 15.8381 21.1645 15.8699C21.0877 15.9016 21.0054 15.9178 20.9223 15.9177C19.6863 15.9129 16.6409 16.3223 16.6359 15.1422C16.6342 14.7918 16.9311 14.1544 17.2683 14.0594C17.2683 14.0594 19.9688 13.1505 20.4718 13.1586Z"
      fill="#999999"
    />
  </svg>
);
export const StarIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.69428 2.30695C8.43748 1.68935 7.56228 1.68935 7.30548 2.30695L5.84148 5.82775L2.03908 6.13255C1.37268 6.18615 1.10228 7.01815 1.61028 7.45335L4.50628 9.93495L3.62148 13.6445C3.46628 14.2949 4.17428 14.8094 4.74548 14.4606L7.99988 12.4725L11.2551 14.4606C11.8255 14.8094 12.5335 14.2949 12.3783 13.6445L11.4935 9.93495L14.3895 7.45335C14.8975 7.01815 14.6271 6.18615 13.9607 6.13335L10.1591 5.82775L8.69428 2.30695Z"
      fill="#FFB800"
    />
  </svg>
);

export const SendIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.63097 2.12196C2.73747 1.67546 1.74847 2.52796 2.05797 3.47746L4.06497 9.62996C4.12174 9.80377 4.22507 9.95869 4.36374 10.0779C4.50241 10.1971 4.6711 10.276 4.85147 10.306L12.7815 11.6275C13.199 11.6975 13.199 12.2975 12.7815 12.3675L4.85197 13.689C4.6716 13.719 4.50291 13.7978 4.36424 13.917C4.22557 14.0362 4.12224 14.1911 4.06547 14.365L2.05797 20.521C1.74797 21.471 2.73747 22.3235 3.63097 21.877L21.378 13.006C22.2075 12.591 22.2075 11.4075 21.378 10.993L3.63097 2.12196Z"
      fill="white"
    />
  </svg>
);

export const NoMessageIcon = () => (
  <svg
    width="246"
    height="136"
    viewBox="0 0 246 136"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="46" width="200" height="90" rx="12" fill="#E9E9E9" />
    <rect x="64" y="18" width="80" height="8" rx="4" fill="#D9D9D9" />
    <rect x="64" y="36" width="140" height="8" rx="4" fill="#F5F5F5" />
    <g filter="url(#filter0_d_1267_706)">
      <rect x="16" y="30" width="200" height="90" rx="12" fill="white" />
    </g>
    <rect x="34" y="48" width="80" height="8" rx="4" fill="#D9D9D9" />
    <rect x="34" y="66" width="140" height="8" rx="4" fill="#F5F5F5" />
    <defs>
      <filter
        id="filter0_d_1267_706"
        x="0"
        y="14"
        width="232"
        height="122"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="8" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1267_706"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1267_706"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const DefaultUser = () => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
      stroke="#000000"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z"
      stroke="#000000"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
